export default "__VITE_ASSET__DVBQYe0k__"